import { v4 as uuidv4 } from 'uuid';

export function SellerRow(props = {}, childrenComponents = []) {
	return {
		componentName: 'SellerRow',
		componentId: uuidv4(),
		title: '',
		props: Object.assign({}, props),
		childrenComponents,
	};
}
